import axios from "axios";
import { getIdToken } from "../../utils/firebaseAuth";
import { useModal } from "../../context/ModalContext";
import { useRouter } from "next/router";
import { toast } from "react-hot-toast";
import { useState } from "react";
import { Spinner } from "@jammable/ui-components/Loader";

// ...

const DeleteModelModal = ({ model, after }) => {
  const [loading, setLoading] = useState(false);
  const { closeModal } = useModal();
  const [error, setError] = useState(null);
  const router = useRouter();

  return (
    <div className="tw-flex tw-flex-col tw-gap-3 tw-text-jam-ink">
      <h2 className="jam-display tw-m-0 tw-pr-10 tw-text-[26px] tw-font-extrabold">
        Delete this voice?
      </h2>
      {error && (
        <div className="tw-rounded-[18px] tw-bg-[#FDE4EC] tw-px-4 tw-py-3 tw-text-sm tw-font-bold tw-text-[#8A1C3B]">
          {error}
        </div>
      )}
      <div className="tw-mb-1 tw-text-[15px] tw-font-semibold tw-leading-6 tw-text-jam-muted">
        {model?.artistname ? (
          <>
            <span className="tw-font-extrabold tw-text-jam-ink">
              {model.artistname}
            </span>{" "}
            will be deleted.
          </>
        ) : (
          "Your voice will be deleted."
        )}{" "}
        <span className="tw-font-extrabold tw-text-jam-ink">
          You will not get your training pass back.
        </span>
      </div>
      <div className="tw-flex tw-gap-2">
        <button
          type="button"
          onClick={() => {
            closeModal("delete-model-modal");
          }}
          className="tw-h-[52px] tw-w-full tw-cursor-pointer tw-rounded-full tw-border-0 tw-bg-jam-lav tw-text-[15px] tw-font-extrabold tw-text-jam-ink"
        >
          Cancel
        </button>
        <button
          type="button"
          disabled={loading}
          onClick={async () => {
            const token = await getIdToken();
            setLoading(true);
            axios
              .delete(`/api/model/deleteModel`, {
                headers: { Authorization: token },
                params: {
                  modelId: model._id,
                },
              })
              .then(() => {
                router.push(`/library?tab=voices`);
                toast.success("Model deleted successfully!");
                if (after) {
                  after();
                }
                setTimeout(() => {
                  setLoading(false);
                }, 1500);
              })
              .catch((err) => {
                // toast.error(
                //   "Something went wrong. Please try again or contact support."
                // );
                if (err?.response?.data?.message) {
                  setError(err.response.data.message);
                }
                setLoading(false);
              });
          }}
          className="tw-flex tw-h-[52px] tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-[#8A1C3B] tw-text-[15px] tw-font-extrabold tw-text-white disabled:tw-opacity-70"
        >
          {loading ? (
            <Spinner className="tw-border-3 tw-border-white" size={4} />
          ) : (
            "Delete voice"
          )}
        </button>
      </div>
    </div>
  );
};

export default DeleteModelModal;
